import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import IntentsGrid from "./IntentsGrid";
import IntentsTiles from "./IntentsTiles";
import IntentsFilter from "./IntentsFilter";
import Tools from "../utils/Tools";
import { useFilter } from '../FilterContext';

function IntentsPage() {
  const location = useLocation();
  const { filters, setFilters } = useFilter();
  const [loadingSummary, setLoadingSummary] = useState(true);
  const [intents, setIntents] = useState([]);
  const [totalCalls, setTotalCalls] = useState(0);
  const [totalIntentCount, setTotalIntentCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  // Fetch summary data from server whenever filters change
  useEffect(() => {
    setLoadingSummary(true);
    const queryParams = new URLSearchParams();
    if (filters.dateRange) {
      queryParams.append("dateRange", filters.dateRange.value);
    }
    Tools.sendRequest("get-intents", queryParams.toString()).then(
      (response) => {
        let intents = response.intents;
        setIntents(intents);
        let totalIntentCount = 0;
        for (let i = 0; i < intents.length; i++) {
          totalIntentCount += intents[i].totalCalls;
        }
        setTotalIntentCount(totalIntentCount);
        setTotalCalls(response.totalCalls);
        setLoadingSummary(false);
      }
    );
  }, [filters]);

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1); // Reset to first page on filter change
  }, []);

  return (
    <div className="container mx-auto p-4">
      <IntentsFilter
        filters={filters}
        setFilters={handleFilterChange}
        intents={intents}
      />
      {loadingSummary ? (
        <div className="flex justify-center items-center h-64">
          <div className="loader"></div>
        </div>
      ) : (
        <>
          <IntentsTiles intents={intents} totalIntentCount={totalIntentCount} totalCalls={totalCalls} />
          <IntentsGrid intents={intents} />
        </>
      )}
    </div>
  );
}

export default IntentsPage;
